import CoursesApiService from "./api/CoursesApiService";
const PER_PAGE = 10;
export const getInstallments = async (studentId, userToken, params = {}) => {
    try {
        let url = `/student/${studentId}/financial-pendencies?per_page=${PER_PAGE}&page=${params.page || 1}`;
        if (params.status)
            url += `&status=${params.status}`;
        const response = await CoursesApiService.get(url, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao buscar parcelas', error);
        throw error;
    }
};
export const getInstallmentsStats = async (studentId, userToken) => {
    try {
        const response = await CoursesApiService.get(`/student/${studentId}/financial-pendencies/stats`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao buscar o resumo financeiro', error);
        throw error;
    }
};
export const payInstallment = async (studentId, installmentId, paymentMethodId, userToken) => {
    try {
        const response = await CoursesApiService.post(`/student/${studentId}/financial-pendencies/${installmentId}/pay`, { payment_method_id: paymentMethodId }, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao gerar a cobrança da parcela', error);
        throw error;
    }
};
export const settleInstallments = async (studentId, installmentIds, reason, userToken) => {
    try {
        await CoursesApiService.post(`/student/${studentId}/financial-pendencies/settle`, {
            financial_pendency_ids: installmentIds,
            reason
        }, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    }
    catch (error) {
        console.error('Erro ao dar baixa nas parcelas', error);
        throw error;
    }
};
export default {
    getInstallments,
    getInstallmentsStats,
    payInstallment,
    settleInstallments
};
